import FirstKv from './components/FirstKv';
import Major from './components/Major';
import Nav from './components/Nav';
import System from './components/System';
import Tc from './components/Tc';

export default function IndexDynamic() {
    return (
        <>
            <Nav />
            <FirstKv />
            <System />
            <Major />
            <Tc />
        </>
    );
}
